import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { CurrenciesForm } from '@/forms/CurrenciesForm/CurrenciesForm'
import { Settings } from '@/interfaces/Settings'
import { Currency } from '@/types/Currency'

import { EditableZone } from './EditableZone'

export interface InvoicingPreviewCurrenciesProps {
  settings: Settings
  currencies: Currency[]
  onMutate: () => void
  children: React.ReactNode
}

export const InvoicingPreviewCurrencies = ({
  settings,
  currencies,
  onMutate,
  children,
}: InvoicingPreviewCurrenciesProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'settings' })
  const [open, setOpen] = useState(false)

  return (
    <>
      <EditableZone
        onClick={() => setOpen(true)}
        ariaLabel={t('invoicing.preview.currencies.title')}
      >
        {children}
      </EditableZone>

      <Dialog
        open={open}
        onOpenChange={(isOpen) => {
          setOpen(isOpen)
          if (!isOpen) onMutate()
        }}
      >
        <DialogContent className="sm:max-w-xl">
          <DialogHeader>
            <DialogTitle>{t('invoicing.preview.currencies.title')}</DialogTitle>
          </DialogHeader>
          <CurrenciesForm
            currencies={currencies}
            defaultValues={{
              primaryCurrency: settings.primaryCurrency || 'CZK',
              alternativeCurrencies: settings.alternativeCurrencies || [],
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
